import { createFileRoute, Outlet } from '@tanstack/react-router';

const URL = 'https://ad-portal-gbrook8344s-team-company.v.monday.app/';
const TITLE = 'Star-Revue Portal · Red Hook & The Village';
const DESC = 'Place an ad in minutes, post a classified, subscribe, send a news tip or a letter to the editor, and mail with Select Mail. Brooklyn’s local papers.';
const IMG = 'https://files-public.monday.com/use1/8d2d6138-0d85-4478-bf31-1f68764cdf6d/LIGHT%20BLUE%20Red%20Hook%20Star-Revue%20logo%20square.png';

// Shared layout. The head tags below control how links to the portal look when shared on Facebook, Instagram, etc.
export const Route = createFileRoute('/_app')({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: 'description', content: DESC },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: URL },
      { property: 'og:site_name', content: 'Star-Revue' },
      { property: 'og:title', content: TITLE },
      { property: 'og:description', content: DESC },
      { property: 'og:image', content: IMG },
      { name: 'twitter:card', content: 'summary' },
      { name: 'twitter:title', content: TITLE },
      { name: 'twitter:description', content: DESC },
      { name: 'twitter:image', content: IMG },
    ],
  }),
  component: AppLayout,
});

function AppLayout() {
  return <Outlet />;
}
